module.exports = __webpack_public_path__ + "img/budget-2.c0d074ba.jpg";